import React, { Component } from 'react';
import Table from './table';

export default class index extends Component {
    render() {
        return (
            <Table {...this.props}>  </Table>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/table/12/index.js